import { useContext } from 'react'
import { TranslateContext } from 'client/common/translator'

const praxisTranslations = (lang, t) => ({
  title: t('lister.products.praxisPlus.title'),
  loginLinkText: t('lister.products.praxisPlus.link'),
  text: t('lister.products.praxisPlus.content'),
  lang
})
const bricoNotLoggedTranslations = (lang, t) => ({
  title: t('lister.products.praxisPlus.title'),
  loginLinkText: t('lister.products.praxisPlus.login'),
  text: t('lister.products.praxisPlus.content'),
  lang
})

const variantMapping = {
  praxis: praxisTranslations,
  brico: bricoNotLoggedTranslations
}

export const getTranslations = (format, lang) => {
  const t = useContext(TranslateContext) // eslint-disable-line
  const fn = variantMapping[format]
  return fn ? fn(lang, t) : {}
}

export const shouldShowPraxisPlusBanner = isLoggedIn => {
  return !isLoggedIn
}
